module.exports = __webpack_public_path__ + "media/customizations/paintedprairie/logo-ed0fb308e149f8a9b87e8969c61e4230.png";